module.exports = __webpack_public_path__ + "img/Coding.680796c6.jpg";